import { useEffect, useState } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { customStyles } from "../Utility/Utility";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";

const Suggestion = () => {
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(false);

  const suggestiondata = async () => {
    setloading(true);
    try {
      const obj = { ProductType: "puja" };
      const res = await AddUpdate("Suggestions/GetData_Suggestions", obj);
      const tabledata = res?.data?.data;

      if (tabledata) {
        const rowdata = JSON.parse(tabledata);
        const finaldata = rowdata?.Table;
        setData(finaldata || []);
     
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    suggestiondata();
  }, []);

  const columns = [
    {
      name: "Image",
      selector: (row) => row.ProductImage,
      cell: (row) => (
        <img
          src={`https://${row.ProductImage}`}
          alt="Product"
          style={{ width: "55px", height: "15px", objectFit: "cover" , borderRadius: "50%"}}
        />
      ),
    },
    {
      name: "Astro Name",
      selector: (row) => row.AstroName,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => row.ProductName,
      sortable: true,
      cell: (row) => (
        <div
          title={row.ProductName}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {row.ProductName}
        </div>
      ),
    },
    {
      name: "Total Amount",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.Status,
      sortable: true,
    }
   
  ];

  return (
    <div className="row">
      <div className="col-12 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={data}
            columns={columns}
            // selectableRowsHighlight
            highlightOnHover
            pagination
            fixedHeader
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />

        )}
      </div>
    </div>
  );
};

export default Suggestion;
